import { Injectable } from '@angular/core';
import { PrettyConsole } from '@app/shared/utils';

import init, { process_large_file } from '@wasm/file_processor';

@Injectable({
  providedIn: 'root',
})
export class FileProcessorService {
  constructor() {
	this.init_wasm();
  }

  async init_wasm() {
    await init('assets/file_processor_bg.wasm');
  }
  async processFile(
    file: File,
    schema: any,
    validation_schema: any,
    maxErrors: number
  ): Promise<any[]> {
    try {
      const result = await process_large_file(
        file,
        schema,
        validation_schema,
        maxErrors
      );
      return result;
    } catch (error) {
      PrettyConsole.ERROR(`Error processing file with WASM: ${error}`);
      throw error;
    }
  }
}
